export default __webpack_public_path__ + "static/media/success.3c5494bd.jpg";